/* Pampino: Scroll-Reveal, exklusive Accordions, Rechtstext-Modal */
(function () {
  var d = document;

  /* Scroll-Reveal mit Stagger (60ms, max. 360ms) */
  function initReveal(root) {
    var groups = root.querySelectorAll('[data-stagger]');
    groups.forEach(function (g) {
      g.querySelectorAll(':scope > [data-reveal]').forEach(function (el, i) {
        el.style.setProperty('--d', Math.min(i * 60, 360) + 'ms');
      });
    });
    var els = root.querySelectorAll('[data-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Accordions: immer nur eines offen */
  d.addEventListener('toggle', function (e) {
    var t = e.target;
    if (!(t instanceof HTMLDetailsElement) || !t.open) return;
    var group = t.closest('[data-accordion]');
    if (!group) return;
    group.querySelectorAll('details[open]').forEach(function (o) { if (o !== t) o.open = false; });
  }, true);

  /* Mobile-Menue: schliessen bei Klick ausserhalb oder auf Link */
  d.addEventListener('click', function (e) {
    d.querySelectorAll('.pp-menu[open]').forEach(function (m) {
      if (!m.contains(e.target) || e.target.closest('.pp-menu__panel a')) m.open = false;
    });
  });

  /* Rechtstexte als Modal (Links behalten ihre echten URLs) */
  function initLegal() {
    var modal = d.getElementById('pp-legal');
    if (!modal || typeof modal.showModal !== 'function') return;
    var title = modal.querySelector('[data-legal-title]');
    var body = modal.querySelector('[data-legal-body]');

    function close() {
      if (!modal.open) return;
      modal.classList.add('is-closing');
      setTimeout(function () { modal.classList.remove('is-closing'); modal.close(); }, 180);
    }

    d.addEventListener('click', function (e) {
      var link = e.target.closest('[data-legal]');
      if (!link || e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      var tpl = d.getElementById('pp-legal-' + link.getAttribute('data-legal'));
      if (!tpl || !tpl.innerHTML.trim()) return;
      e.preventDefault();
      title.textContent = link.textContent.trim();
      body.innerHTML = tpl.innerHTML;
      modal.showModal();
      body.scrollTop = 0;
    });

    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('[data-legal-close]')) close();
    });
    modal.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
  }

  function init() { initReveal(d); initLegal(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();

  /* Theme-Editor: neu geladene Sektionen sofort sichtbar */
  d.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-in'); });
  });
})();
